export const FALLBACK_NOTICE_LANGUAGE = 'en';

export const GUARANTEE_NOTICE_LANGUAGES: string[] = [
  'bg',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'es',
  'et',
  'fi',
  'fr',
  'ga',
  'hr',
  'hu',
  'it',
  'lt',
  'lv',
  'nl',
  'pl',
  'pt',
  'ro',
  'sk',
  'sl',
  'sv',
];

export const COUNTRY_NOTICE_LANGUAGE: Record<string, string | undefined> = {
  AT: 'de',
  BE: 'nl',
  BG: 'bg',
  CH: 'de',
  CY: 'el',
  CZ: 'cs',
  DE: 'de',
  DK: 'da',
  EE: 'et',
  ES: 'es',
  FI: 'fi',
  FR: 'fr',
  GB: 'en',
  GR: 'el',
  HR: 'hr',
  HU: 'hu',
  IE: 'en',
  IS: 'en',
  IT: 'it',
  LI: 'de',
  LT: 'lt',
  LU: 'de',
  LV: 'lv',
  MT: 'en',
  NL: 'nl',
  NO: 'en',
  PL: 'pl',
  PT: 'pt',
  RO: 'ro',
  SE: 'sv',
  SI: 'sl',
  SK: 'sk',
};

export const guaranteeNoticeAsset = (languageCode: string): string =>
  `legal/guarantee-notice/${languageCode}.svg`;

export const resolveGuaranteeNoticeLanguage = (
  shopLanguageCode: string,
  deliveryCountryIsoCode2: string | null,
): string => {
  const shopLanguage: string = shopLanguageCode.toLowerCase();

  if (GUARANTEE_NOTICE_LANGUAGES.includes(shopLanguage)) {
    return shopLanguage;
  }

  const countryLanguage: string | undefined = deliveryCountryIsoCode2
    ? COUNTRY_NOTICE_LANGUAGE[deliveryCountryIsoCode2.toUpperCase()]
    : undefined;

  return countryLanguage ?? FALLBACK_NOTICE_LANGUAGE;
};
